import { useMapContext } from "@evergis/react";
import { useMemo } from "react";

export const useSGisLayers = (recurse?: boolean, excludeInactive?: boolean) => {
  const { map } = useMapContext();

  return useMemo(() => map.getLayers(recurse, excludeInactive), [map, recurse, excludeInactive]);
};
